/* eslint-disable react-hooks/rules-of-hooks */
import React from "react";
import styled from "styled-components";
import { useSelector, useDispatch, batch } from "react-redux";
import { useNavigationType } from "react-router";
import {
  fetchSearchDate,
  fetchSearchPeriodType,
  fetchSearchPartnerAndBranch,
  fetchReset,
} from "redux/slices/sales/salesSlice";
import { updateBranchList } from "redux/slices/partner/partnerSlice";

import { getToday, getCalendar, getDateAdd } from "utils/date";
import iconChevron from "assets/icons/icon_chevron_black.svg";
import iconLoading from "assets/icons/icon_loading.gif";

import Tab from "components/ui/Tab";

/**
 * [일간, 주간, 월간 기간 검색]
 */

export const searchInfo = ({ onChange }) => {
  const dispatch = useDispatch();
  const navigationType = useNavigationType();
  const today = getToday();

  let {
    searchDate,
    searchPeriodType,
    searchPartner,
    searchBranch,
    summaryInfo,
  } = useSelector((state) => state.sales);
  const { seqPartner, seqPartnerBranch, headquarterYn } = useSelector(
    (state) => state.partner
  );

  if (!searchDate) searchDate = today;

  const eventHandler = {
    prev: () => {
      const month = searchPeriodType == "monthly" ? -1 : 0;
      const day =
        searchPeriodType == "daily"
          ? -1
          : searchPeriodType == "weekly"
            ? -7
            : 0;
      const newSearchDate = getDateAdd(searchDate, 0, month, day);
      dispatch(fetchSearchDate(newSearchDate));
    },
    next: () => {
      const month = searchPeriodType == "monthly" ? 1 : 0;
      const day =
        searchPeriodType == "daily" ? 1 : searchPeriodType == "weekly" ? 7 : 0;
      const newSearchDate = getDateAdd(searchDate, 0, month, day);
      dispatch(fetchSearchDate(newSearchDate));
    },
    changeTab: (index) => {
      switch (index) {
        case 0:
          batch(() => {
            dispatch(fetchSearchPeriodType("daily"));
            dispatch(fetchSearchDate(today));
          });
          return;

        case 1:
          batch(() => {
            dispatch(fetchSearchPeriodType("weekly"));
            dispatch(
              fetchSearchDate(
                new Date(today).getStartDateInWeek().getCalendar()
              )
            );
          });
          return;

        case 2:
          batch(() => {
            dispatch(fetchSearchPeriodType("monthly"));
            dispatch(
              fetchSearchDate(
                new Date(today).getStartDateInMonth().getCalendar()
              )
            );
          });
      }
    },
  };

  const render = () => {
    const getDateInfo = () => {
      const getDate = () => {
        let text = "";
        switch (searchPeriodType) {
          case "daily":
            text = new Date(searchDate).format("zm월 zd일 ww");
            if (searchDate == today) text += "<span>오늘</span>";
            break;

          case "weekly":
            const month = new Date(searchDate).add(0, 0, 3).getMonth() + 1;
            const weekInMonth = new Date(searchDate).getWeekInMonth();
            const startDate = new Date(searchDate).format("zm.sd(sw)");
            const endDate = new Date(searchDate)
              .add(0, 0, 6)
              .format("zm.sd(sw)");
            const period = `<span>${startDate}~${endDate}</span>`;
            text = `${month}월 ${weekInMonth}주차 ${period}`;
            // if(date == getCalendar(new Date().getStartDateInWeek())) text += "<span>이번주</span>";
            break;

          case "monthly":
            text = new Date(searchDate).format("yyyy년 zm월");
            if (searchDate == getCalendar(new Date().getStartDateInMonth()))
              text += "<span>이번달</span>";
        }
        return text;
      };
      const getButtonState = (direction) => {
        if (summaryInfo.isLoading) return true;
        if (direction == "next") {
          switch (searchPeriodType) {
            case "daily":
              return today == searchDate;
            case "weekly":
              return getCalendar(new Date().getStartDateInWeek()) == searchDate;
            case "monthly":
              return (
                getCalendar(new Date().getStartDateInMonth()) == searchDate
              );
          }
        }
        return false;
      };
      return (
        <div className="dateInfo">
          <ul>
            <li>
              <button
                className="prev"
                onClick={eventHandler.prev}
                disabled={getButtonState("prev")}
              ></button>
            </li>
            <li>
              <h4 dangerouslySetInnerHTML={{ __html: getDate() }} />
            </li>
            <li>
              <button
                className="next"
                onClick={eventHandler.next}
                disabled={getButtonState("next")}
              ></button>
            </li>
          </ul>
        </div>
      );
    };

    const getTabIndex = () => {
      switch (searchPeriodType) {
        case "daily":
          return 0;
        case "weekly":
          return 1;
        case "monthly":
          return 2;
      }
    };

    const getTabList = () => {
      return [{ name: "일간" }, { name: "주간" }, { name: "월간" }];
    };

    return (
      <Wrapper>
        <Tab
          index={getTabIndex()}
          data={getTabList()}
          onChange={eventHandler.changeTab}
        />
        {getDateInfo()}
      </Wrapper>
    );
  };
  return render();
};

const Wrapper = styled.div`
  & {
    margin-bottom: var(--padding);
  }
  .dateInfo {
    padding-top: 2px;
  }
  .dateInfo h4 {
    white-space: nowrap;
    font-weight: bold;
    color: var(--blue);
  }
  .dateInfo h4 span {
    font-weight: 400;
    color: var(--blueBlack);
  }
  .dateInfo h4 span:before {
    content: "·";
    margin: 0 0.25em;
  }

  .dateInfo ul {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: center;
  }
  .dateInfo ul li:first-child,
  .dateInfo ul li:last-child {
    width: 2em;
    height: 2em;
  }
  .dateInfo ul button {
    width: 100%;
    height: 100%;
    background-color: transparent;
    border: none;
  }
  .dateInfo ul button:after {
    content: "";
    display: flex;
    width: 100%;
    height: 100%;
    background: url(${iconChevron}) no-repeat center center / 12px;
  }
  .dateInfo ul button.prev {
    transform: rotate(-180deg);
  }
  .dateInfo ul button:disabled:after {
    opacity: 0.15;
  }
`;

export default searchInfo;
